import { useState, useContext, useEffect } from 'react';

import { MyContext } from '../../Store';
import { trans } from '../../utils';
import { Modal } from './Modal';

export const SaveModal = () => {
  const [state, dispatch, saveData] = useContext(MyContext);

  const [isSavedDataModalOpen, setIsSavedDataModalOpen] = useState(false);
  const [isUnsavedWarningModalOpen, setIsUnsavedWarningModalOpen] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [projectListURL, setProjectListURL] = useState('https://localhost:8000/');

  const handleClick = () => {
    setIsSavedDataModalOpen(true);
    saveData();
  };

  const handleSaveClick = () => {
    setIsUnsavedWarningModalOpen(false);
    saveData();
  };

  const handleConfirmLeave = () => {
    if (pendingAction === 'reload') {
      window.location.reload();
    } else if (pendingAction === 'navigate') {
      window.location.href = projectListURL;
    } else if (pendingAction === 'close') {
      window.removeEventListener('beforeunload', () => {});
      window.close();
    }
  };

  const handleCloseSavedModal = () => setIsSavedDataModalOpen(false);
  const handleCloseWarningModal = () => setIsUnsavedWarningModalOpen(false);

  useEffect(() => {
    const handleBeforeUnload = event => {
      if (!state.isDataSaved) {
        event.preventDefault();
        event.returnValue = '';
        setIsUnsavedWarningModalOpen(true);

        if (event.type === 'beforeunload') {
          setPendingAction('reload');
        } else if (event.type === 'popstate') {
          setPendingAction('navigate');
        } else {
          setPendingAction('close');
        }
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handleBeforeUnload);
    };
  }, [state.isDataSaved]);

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      try {
        const url = window.parent?.globalConfig?.['configurator-project-list'];
        if (url) {
          setProjectListURL(url);
        } else {
          console.warn('Nie znaleziono konfiguracji w window.parent.globalConfig');
        }
      } catch (error) {
        console.error('Błąd przy odczycie z window.parent', error);
      }
    }
  }, []);

  return (
    <>
      <button className="btn download-btn order-btn" onClick={handleClick}>
        {trans('ZAPISZ')}
      </button>

      {isSavedDataModalOpen && (
        <Modal handleClose={() => handleCloseSavedModal()} title={trans('Lista zapisanych projektów')}>
          <div>
            <div>{trans('Twoje zapisane projekty możesz przejrzeć tutaj')}:</div>
            <div>
              <a href={projectListURL} target="_blank" rel="noopener noreferrer">
                {projectListURL}
              </a>
            </div>
          </div>
        </Modal>
      )}

      {isUnsavedWarningModalOpen && (
        <Modal handleClose={handleCloseWarningModal} title={trans('Masz niezapisany projekt produktu')}>
          <div>
            <div>{trans('Czy chcesz zapisać?')}</div>
            <div className="modal__actions">
              <button className="btn confirm-btn" onClick={handleSaveClick}>
                {trans('Tak, zapisz')}
              </button>
              <button className="btn cancel-btn" onClick={handleConfirmLeave}>
                {trans('Nie, opuść')}
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
